module.exports = __webpack_public_path__ + "img/pr-3.8d24d323.png";